<template>
  <div class="news">
    <header>
      <van-icon
        :name="isDirection ? 'arrow' : 'arrow-left'"
        @click="
          $router.push({
            path: '/college',
            query: {
              isApp: $route.query.isApp,
              language: $route.query.language
            }
          })
        "
      />
    </header>
    <main>
      <div class="commont_header">
        <div class="header_content">
          <b>{{ $t("300184") }}</b>
          <p>{{ $t("300187") }}</p>
        </div>
        <div class="tab">
          <van-tabs
            v-model="active"
            @change="tabchange"
            title-active-color="#000"
            title-inactive-color="rgba(153, 153, 153, 1)"
            :ellipsis="false"
          >
            <div v-for="(item, index) in categorys" :key="index">
              <van-tab v-if="index === 0" :title="$t('300192')"></van-tab>
              <van-tab v-else :title="item.category"></van-tab>
            </div>
          </van-tabs>
        </div>
      </div>
      <div class="commont_body" v-if="list.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          :loading-text="text"
          @load="onLoad"
        >
          <div
            @click="
              $router.push({
                path: '/college_detail',
                query: {
                  id: item.id,
                  categoryid: id,
                  path: '/study',
                  activeid: active,
                  isApp: $route.query.isApp,
                  language: $route.query.language,
                  istime: true
                }
              })
            "
            v-for="(item, index) in list"
            :key="index"
          >
            <dl v-if="item.id">
              <dt><img :src="item.imgs" alt="" /></dt>
              <dd>
                <p>{{ item.title }}</p>
                <div class="commont_content">
                  {{ htmlToString(item.content) }}
                </div>
                <p class="more" v-show="item.content">({{ $t("300188") }})</p>
              </dd>
            </dl>
          </div>
        </van-list>
      </div>
      <div class="nodata" v-else>
        <van-empty class="custom-image" :description="$t('300108')">
          <svg slot="image" class="icon" aria-hidden="true">
            <use xlink:href="#icon-jilu1"></use>
          </svg>
        </van-empty>
      </div>
    </main>
  </div>
</template>

<script>
import { Tab, Tabs, List, Icon, Empty } from "vant";
import { getcategorys, getListdata } from "@/api/resource";
import { mapGetters } from "vuex";
export default {
  name: "study",
  components: {
    vanTab: Tab,
    vanTabs: Tabs,
    vanList: List,
    vanIcon: Icon,
    vanEmpty: Empty
  },
  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: false,
      language: "",
      ind: 1,
      categorys: [],
      length: 0,
      text: " "
    };
  },
  computed: {
    ...mapGetters(["isDirection"])
  },
  created() {
    this.getcategorys();
    this.getListdata();
    this.id = this.$route.query.id;
    this.active = this.$route.query.activeid
      ? Number(this.$route.query.activeid)
      : this.active;
  },
  methods: {
    tabchange() {
      this.active == 0
        ? (this.id = undefined)
        : (this.id = this.categorys[this.active-1].id);
      getListdata({ module: 2, categoryId: this.id }).then(res => {
        this.list = res.data.items;
        this.ind = 1;
        this.length = res.data.total;
      });
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.ind++;
      setTimeout(() => {
        // 加载状态结束

        this.loading = false;
        getListdata({ module: 2, page: this.ind, categoryId: this.id }).then(
          res => {
            this.list = this.list.concat(res.data.items)
          }
        );
        // 数据全部加载完成
        if (this.list.length >= this.length) {
          this.finished = true;
        }
      }, 1000);
    },
    getcategorys() {
      getcategorys({ module: 2 }).then(res => {
        this.categorys = res.data;
        this.categorys.unshift({});
      });
    },
    getListdata() {
      getListdata({
        module: 2,
        page: this.ind,
        categoryId: this.$route.query.id
      }).then(res => {
        this.list = res.data.items;
        this.length = res.data.total;
      });
    },
    htmlToString(html) {
      let relStyle = /style\s*?=\s*?([‘"])[\s\S]*?\1/g; //去除样式
      let relTag = /<.+?>/g; //去除标签
      let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g; // 清除类名
      let rel = /&nbsp;/gi;
      let rel1 = /&ldquo;/gi;
      let rel2 = /&rdquo;/gi;
      let newHtml = "";
      if (html) {
        newHtml = html.replace(relStyle, "");
        newHtml = newHtml.replace(relTag, "");
        newHtml = newHtml.replace(relClass, "");
        newHtml = newHtml.replace(rel, " ");
        newHtml = newHtml.replace(rel1, '"');
        newHtml = newHtml.replace(rel2, '"');
      }
      return newHtml;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
@import "index.scss";

.news {
  background: #f5f7f9;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  header {
    height: torem(38);
    background: #fff;
    flex-shrink: 0;
  }
  img {
    height: 100%;
    width: 100;
    object-fit: cover;
  }
  main {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;

    .commont_body {
      flex: 1;
      overflow-y: scroll;

      dl {
        height: torem(267);

        dd {
          p {
            &:nth-child(1) {
              height: torem(23);
            }

            &:nth-child(2) {
              margin-top: torem(6);
            }
          }
        }
      }
    }
  }
}
.nodata {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}
.custom-image {
  /deep/ .van-empty__image {
    width: torem(56);
    height: torem(56);
    text-align: center;
  }
  /deep/ .van-empty__description {
    font-size: torem(12);
  }
  svg {
    width: torem(56);
    height: torem(56);
  }
  .van-empty__description {
    font-size: torem(12);
  }
}
.tab-class {
  flex: none !important;
}
/deep/ .van-tabs {
  .van-tab {
    margin: 0 torem(10);
  }
}
/deep/ .van-tabs__nav {
  flex: none;
  min-width: torem(300);
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/view/college/study.vue